import React, { useState, useRef, useEffect } from "react";

const DEFAULT_FALLBACK = "/images/event-pic.png";

const LazyImage = ({ src, alt, className = "", style = {}, fallback = DEFAULT_FALLBACK }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [inView, setInView] = useState(false);
  const imgRef = useRef(null);
  const imageSrc = !src || error ? fallback : src;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    if (imgRef.current) observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={imgRef} className={`lazy-image-wrapper ${className}`} style={{ position: "relative", overflow: "hidden", ...style }}>
      {/* Skeleton */}
      {!loaded && (
        <div
          className="lazy-image-skeleton"
          style={{
            position: "absolute",
            inset: 0,
            background: "#e5e5e5",
            animation: "skeletonPulse 1.5s ease-in-out infinite",
          }}
        />
      )}

      {inView && (
        <img
          src={imageSrc}
          alt={alt}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            opacity: loaded ? 1 : 0,
            transition: "opacity 0.4s ease",
          }}
        />
      )}

      <style>{`
        @keyframes skeletonPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default LazyImage;
